import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import httpClient from '../../../http/HttpRequest';
import { GET_CUSTOMER, GET_STATES, SAVE_CUSTOMER } from '../../../data/url';
import Alert from '../../../feature/Alert';
import FormLayout from '../layout/FormLayout';

export default function AddCustomer() {
  const { id } = useParams();
  let cType = 0;
  const action = typeof id === 'undefined' ? 'ADD' : 'UPDATE';
  const { customerType } = useParams();
  const [state, setState] = useState([]);
  let title = "add_customer";
  if (action === 'ADD') {
    if (customerType === 'vendor') {
      title = "add_vendor";
      cType = 1;
    }
  } else {
    if (customerType === 'vendor') {
      title = "edit_vendor";
    } else {
      title = "edit_customer";
    }
  }

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [directSubmit, setDirectSubmit] = useState(1);
  const [formData, setFormData] = useState({
    formTitle: 'Add Product',
    formFields: [
      { label: 'full_name', id: 'full_name', type: 'text', name: 'full_name', placeholder: 'enter_name', value: '', required: true, className: "col-md-4" },
      { label: 'mobile', id: 'mobile', type: 'number', name: 'mobile', placeholder: 'enter_mobile', value: '', required: true, className: "col-md-4" },
      { label: 'email', id: 'email', type: 'email', name: 'email', placeholder: 'enter_email', value: '', className: "col-md-4" },
      { label: 'address', id: 'address', type: 'textarea', name: 'address', placeholder: 'enter_address', value: '', className: "col-md-4" },
      { label: 'city', id: 'city', type: 'text', name: 'city', placeholder: 'enter_city', value: '', className: "col-md-4" },
      { label: 'pincode', id: 'pincode', type: 'number', name: 'pincode', placeholder: 'enter_pincode', value: '', className: "col-md-4" },
      { label: 'state', id: 'state', type: 'select', select: true, name: 'state', value: '', options: [], className: "col-md-4" },
      { label: 'date_of_birth', id: 'date_of_birth', type: 'date', name: 'date_of_birth', value: '', className: "col-md-4" },
    ],
    formErrors: { full_name: '', mobile: '', email: '', address: '', city: '', pincode: '', state: '', date_of_birth: '' },
  });

  useEffect(() => {
    if (state.length === 0) {
      getState();
    }
    if (action === 'UPDATE') {
      setFormData(prevFormData => {
        const statusFieldExists = prevFormData.formFields.some(field => field.id === 'status');
        if (!statusFieldExists) {
          const newFormField = {
            label: 'status', id: 'status', type: 'radio', name: 'status', value: '', required: true, className: "col-12", options: [
              { label: 'active', value: "1", class: "success" },
              { label: 'deactive', value: "2", class: "danger" },
            ]
          };
          const newFormErrors = {
            ...prevFormData.formErrors,
            status: ''
          };
          const updatedFormFields = [...prevFormData.formFields, newFormField];
          return {
            ...prevFormData,
            formFields: updatedFormFields,
            formErrors: newFormErrors
          };
        }
        return prevFormData;
      });
    }
  }, [id, cType]);

  useEffect(() => {
    if (id && state.length > 0) {
      getCustomerData(id);
    }
  }, [id, state])

  const getState = async (e) => {
    const res = await httpClient.post(GET_STATES, {});
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        let options = [];
        result.data.forEach((row, index) => {
          options.push({ label: row.name, value: row.id });
        });
        setState(options);
        updateFormFieldOptions(options, 'state');
      }
    }
  }

  const getCustomerData = async () => {
    if (id) {
      const res = await httpClient.post(GET_CUSTOMER, { customer_id: id });
      if (res.requestStatus === 'OK') {
        const result = res.result;
        if (result.status === 1) {
          setFormData(prevFormData => {
            const updatedFormFields = prevFormData.formFields.map(field => {
              if (field.name in result.data) {
                if (field.name === 'state') {
                  const c = state.find(element => element.value === result.data[field.name]);
                  field.value = c;
                } else {
                  field.value = result.data[field.name];
                }
              }
              return field;
            });
            return {
              ...prevFormData,
              formFields: updatedFormFields,
            };
          });
        } else {
          Alert.error(res.message);
          navigate('/root/' + customerType);
        }
      }
    }
  };

  const updateFormFieldOptions = (newOptions, fieldName) => {
    setFormData(prevFormData => {
      const updatedFormFields = prevFormData.formFields.map(field => {
        if (field.name === fieldName) {
          return {
            ...field,
            options: newOptions,
          };
        }
        return field;
      });
      return {
        ...prevFormData,
        formFields: updatedFormFields,
      };
    });
  };

  function handleFieldChange(fieldName, value) {
    setDirectSubmit(0);
    setFormData((prevFormData) => {
      const updatedFormFields = prevFormData.formFields.map((field) =>
        field.name === fieldName ? { ...field, value: value } : field
      );
      return {
        ...prevFormData,
        formFields: updatedFormFields,
      };
    });
  }

  function handleFieldBlur(fieldName, value) {
    setDirectSubmit(0);
    validateField(fieldName, value);
  }

  function validateField(fieldName, value) {
    setFormData((prevFormData) => {
      const updatedErrors = { ...prevFormData.formErrors };
      if (fieldName === 'full_name') {
        updatedErrors.full_name = value.trim() === '' ? 'field_required' : '';
      }
      if (fieldName === 'mobile') {
        updatedErrors.mobile = '';
        if (value.trim() === '') {
          updatedErrors.mobile = 'field_required';
        } else if (isNaN(Number(value))) {
          updatedErrors.mobile = 'mobile_sb_containt_number';
        } else if (value.length != 10) {
          updatedErrors.mobile = 'mobile_sb_10_digit';
        }
      }
      return {
        ...prevFormData,
        formErrors: updatedErrors,
      };
    });

    return formData.formErrors;

  }

  function handleSubmit(e) {
    e.preventDefault();
    let post = {};
    let hasErrors = false;
    const updatedFormFields = formData.formFields.map((field) => {
      const allError = validateField(field.name, field.value);
      const error = allError[field.name];
      if (error !== '' && typeof error !== undefined) {
        hasErrors = true;
      } else {
        if (typeof field.value === 'object' && field.value !== null) {
          post[field.name] = field.value.value;
        } else {
          post[field.name] = field.value;
        }
      }
      return field;
    });
    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
    }));
    if (!hasErrors && directSubmit == 0) {
      if (action === 'UPDATE') post['customer_id'] = id;
      if (action === 'ADD') post['customer_as_vendor'] = cType;
      subtmitData(post);
    } else {
      if (action === 'UPDATE') {
        Alert.warning(t('you_did_not_change_anything'));
      } else {
        Alert.warning(t('mandetory_fields'));
      }
    }
  }

  const subtmitData = async (post) => {
    post['date_of_birth'] = post['date_of_birth'] === '' ? null : post['date_of_birth'];
    post['state'] = post['state'] === '' ? null : post['state']; 
    const res = await httpClient.post(SAVE_CUSTOMER, post);
    if (res.requestStatus == "OK") {
      const result = res.result;
      if (result.status == 1) {
        Alert.success(result.message);
        navigate('/root/' + customerType);
      } else {
        Alert.failure(result.message);
      }
    }
  }

  function handleReset() {
    const updatedFormFields = formData.formFields.map((field) => ({
      ...field,
      value: '',
    }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
      formErrors: {},
    }));
  }

  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader
          title={title}
          subTitle={customerType}
          subTitleLink={`root/${customerType}`}
        />
        {action === 'UPDATE' && (
          <ul className="nav nav-tabs ml-3 mb-2">
            <li className="nav-item">
              <Link className="nav-link active" to={`/root/${customerType}/edit/${id}`}>{t('basic')}</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={`/root/${customerType}/taxDetails/${id}`}>{t('billing_details')}</Link>
            </li>
          </ul>
        )}
        <div className='col-md-12 m-auto'>
          <FormLayout
            formTitle={formData.formTitle}
            formFields={formData.formFields}
            formErrors={formData.formErrors}
            onFieldChange={handleFieldChange}
            onFieldBlur={handleFieldBlur}
            onSubmit={handleSubmit}
            handleReset={handleReset}
          />
        </div>
      </div>
    </AdminLayout>
  )
}
